import axios from "axios";
import { CREATE_ERRORS, SET_LOADER, CLOSE_LOADER, SET_MESSAGE, REDIRECT_TRUE, REDIRECT_FALSE, REMOVE_ERRORS, SET_POSTS, SET_POST, POST_REQUEST, SET_UPDATE_ERRORS, RESET_UPDATE_ERRORS, SET_UPDATE_IMAGE_ERRORS, RESET_UPDATE_IMAGE_ERRORS, SET_All_POSTS, SET_DETAILS, SET_COMMENTS } from "../Types/postTypes";
import { BACKEND_API } from "../../services/helper";

export const createAction = (postData) => {
    return async (dispatch, getState) => {
        const { AuthReducer : { token } } = getState();
        // Now, here our code going to be executed.
        dispatch({ type : SET_LOADER });
        try
        {
            const config = {
                headers : {
                    Authorization : `Bearer ${token}`
                }
            }
            
            const { data, data : { msg } } = await axios.post(`${BACKEND_API}/create-post`, postData, config);
            console.log(data);
            dispatch({ type : CLOSE_LOADER });
            dispatch({ type : REMOVE_ERRORS });
            dispatch({ type : REDIRECT_TRUE });
            dispatch({ type : SET_MESSAGE, payload : msg });
        }
        catch(error)
        {
            const { errors } = error.response.data;
            console.log(errors);
            dispatch({ type : CLOSE_LOADER });
            dispatch({ type : CREATE_ERRORS, payload : errors });
            dispatch({ type : REDIRECT_FALSE });
            dispatch({ type : SET_MESSAGE, payload : "" });
        }
    }
}

export const fetchPostsAction = (id, page) =>
{
    return async (dispatch, getState) => {
        const { AuthReducer : { token } } = getState();
        dispatch({ type : SET_LOADER });
        
        const config = {
            headers : {
                Authorization : `Bearer ${token}`
            }
        }
        
        try
        {
            
            const { data : { response, count, perPage } }  = await axios.get(`${BACKEND_API}/posts/${id}/${page}`, config);
            console.log({ response, count, perPage });
            
            dispatch({ type : CLOSE_LOADER });
            dispatch({ type : SET_POSTS, payload : { response, count, perPage } });
        }
        catch(error)
        {
            const { errors } = error.response.data;
            dispatch({ type : CLOSE_LOADER });
        }
    }
}

export const fetchPostByIdAction = (id) =>
{
    return async (dispatch, getState) =>
    {
        const {
            AuthReducer : { token }
        } = getState();
        dispatch({ type : SET_LOADER });
        
        const config = {
            headers : {
                Authorization : `Bearer ${token}`
            }
        }
        
        try
        {
            const { data : {post} } = await axios.get(`${BACKEND_API}/post/${id}`, config);
            dispatch({ type : CLOSE_LOADER });
            dispatch({ type : SET_POST, payload : post });
            dispatch({ type : POST_REQUEST });
        }
        catch(error)
        {
            const { errors } = error.response.data;
            dispatch({ type : CLOSE_LOADER });
        }
        
    }
}

export const updatePostAction = (editData) => {
    
    return async (dispatch, getState) =>
    {
        const {
            AuthReducer : { token }
        } = getState();
        dispatch({ type : SET_LOADER });
        
        const config = {
            headers : {
                Authorization : `Bearer ${token}`
            }
        }
        
        try
        {
            const { data } = await axios.post(`${BACKEND_API}/post/update`, editData, config);
            dispatch({ type : CLOSE_LOADER });
            dispatch({ type : RESET_UPDATE_ERRORS });
            dispatch({ type : REDIRECT_TRUE });
            dispatch({ type : SET_MESSAGE, payload : data.msg });
        }
        catch(error)
        {
            const { errors } = error.response.data;
            dispatch({ type : SET_UPDATE_ERRORS, payload : errors });
            dispatch({ type : CLOSE_LOADER });
        }
        
    }
    
}

export const updatePostImageAction = (imageData) =>
{
    return async (dispatch, getState) => {
        const {
            AuthReducer : { token }
        } = getState();
        
        dispatch({ type : SET_LOADER });
        
        const config = {
            headers : {
                Authorization : `Bearer ${token}`
            }
        }
        
        try
        {
            const { data } = await axios.post(`${BACKEND_API}/post/updateImage`, imageData, config);
            console.log(data);
            dispatch({ type : CLOSE_LOADER });
            dispatch({ type : REDIRECT_TRUE });
            dispatch({ type : RESET_UPDATE_IMAGE_ERRORS });
            dispatch({ type : SET_MESSAGE, payload : data.msg });
        }
        catch(error)
        {
            const { errors } = error.response.data;
            dispatch({ type : SET_UPDATE_IMAGE_ERRORS, payload : errors });
            dispatch({ type : CLOSE_LOADER });
        }
    }
}

export const fetchAllPostsAction = (page) =>
{
    return async (dispatch) =>
    {
        try
        {
            dispatch({ type : SET_LOADER });
            const { data : { response, count, perPage } } = await axios.get(`${BACKEND_API}/posts/${page}`);
            dispatch({ type : CLOSE_LOADER });
            dispatch({ type : SET_All_POSTS, payload : {response, count, perPage} });
            
        }
        catch(error)
        {
            console.log(error);
            dispatch({ type : CLOSE_LOADER });
        }
    }
}

export const fetchDetailsAction = (slug) => 
{
    return async (dispatch) => {
        try
        {
            dispatch({ type : SET_LOADER });
            const { data : { post, comments } } = await axios.get(`${BACKEND_API}/details/${slug}`);
            console.log({ post, comments });
            dispatch({ type : SET_DETAILS, payload : post });
            dispatch({ type : SET_COMMENTS, payload : comments });
            dispatch({ type : CLOSE_LOADER });
        }
        catch(error)
        {
            console.log(error);
            dispatch({ type : CLOSE_LOADER });
        }
    }
}

export const postCommentAction = ({ comment, user, postId }) => 
{
    return async (dispatch, getState) =>
    {
        const {
            AuthReducer : { token }
        } = getState();
        
        dispatch({ type : SET_LOADER });
        
        const config = {
            headers : {
                Authorization : `Bearer ${token}`
            }
        }
        
        try
        {
            const { data, data : { msg } } = await axios.post(`${BACKEND_API}/details/comment`, { comment, user, postId }, config);
            console.log(data);
            dispatch({ type : CLOSE_LOADER });
            //dispatch({ type : SET_MESSAGE, payload : msg });
        }
        catch(error)
        {
            console.log(error);
        }
    }
}